import { IAction, IActionFailed, IActionSuccess, LoadingStates } from '../common.types';
import { IBookmark, JobTaxonomyType } from '@careerhub/api';
import * as actions from './actions';
import { ICareerState } from './types';
import { ICareerHubModuleState } from '../../models';
import { CareerState } from '../StoreConstants';

export const getInitialCareerState = (): ICareerState => {
  return {
    addBookmarkStatus: LoadingStates.NOT_STARTED,
    bookmarks: [],
    fetchBookmarksStatus: LoadingStates.NOT_STARTED,
    fetchTaxonomyTypeStatus: LoadingStates.NOT_STARTED,
    removeBookmarkStatus: LoadingStates.NOT_STARTED,
    errorMessage: '',
    isChatOpen: screen.width < 425 ? false : true,
    isChatInIntialState: true,
    taxonomyTypes: [],
  };
};

export const careerStateSelector = (state: ICareerHubModuleState) => state[CareerState] ?? getInitialCareerState();

export function careerStateReducer(prev: ICareerState = getInitialCareerState(), action: IAction): ICareerState {
  switch (action.type) {
    case actions.CareerActionType.ADD_BOOKMARK:
      return {
        ...prev,
        addBookmarkStatus: LoadingStates.STARTED,
        errorMessage: '',
      };
    case actions.CareerActionType.ADD_BOOKMARK_FAILED:
      return {
        ...prev,
        addBookmarkStatus: LoadingStates.FAILED,
        errorMessage: (action as IActionFailed).errorMessage,
      };
    case actions.CareerActionType.ADD_BOOKMARK_SUCCESS:
      const addBookmarkAction = action as IActionSuccess<string>;
      const newBookmark: IBookmark = {
        id: addBookmarkAction.payload,
        isActive: true,
        type: 'Role',
      };
      return {
        ...prev,
        addBookmarkStatus: LoadingStates.SUCCEEDED,
        bookmarks: [...prev.bookmarks, newBookmark],
      };
    case actions.CareerActionType.LOAD_BOOKMARKS:
      // Only queue to fetch if we haven't already fetched
      const newFetchState =
        prev.fetchBookmarksStatus === LoadingStates.NOT_STARTED ? LoadingStates.STARTED : prev.fetchBookmarksStatus;
      return {
        ...prev,
        fetchBookmarksStatus: newFetchState,
        errorMessage: '',
      };
    case actions.CareerActionType.LOAD_BOOKMARKS_FAILED:
      return {
        ...prev,
        fetchBookmarksStatus: LoadingStates.FAILED,
        errorMessage: (action as IActionFailed).errorMessage,
      };
    case actions.CareerActionType.LOAD_BOOKMARKS_SUCCESS:
      const fetchBookmarksAction = action as IActionSuccess<IBookmark[]>;
      return {
        ...prev,
        fetchBookmarksStatus: LoadingStates.SUCCEEDED,
        bookmarks: [...fetchBookmarksAction.payload],
      };
    case actions.CareerActionType.LOAD_TAXONOMYTYPE:
      const newTaxonomyTypeFetchState =
        prev.fetchTaxonomyTypeStatus === LoadingStates.NOT_STARTED
          ? LoadingStates.STARTED
          : prev.fetchTaxonomyTypeStatus;
      return {
        ...prev,
        fetchTaxonomyTypeStatus: newTaxonomyTypeFetchState,
        errorMessage: '',
      };
    case actions.CareerActionType.LOAD_TAXONOMYTYPE_FAILED:
      return {
        ...prev,
        fetchTaxonomyTypeStatus: LoadingStates.FAILED,
        errorMessage: (action as IActionFailed).errorMessage,
      };
    case actions.CareerActionType.LOAD_TAXONOMYTYPE_SUCCESS:
      const fetchTaxonomyTypeAction = action as IActionSuccess<JobTaxonomyType[]>;
      return {
        ...prev,
        fetchTaxonomyTypeStatus: LoadingStates.SUCCEEDED,
        taxonomyTypes: [...fetchTaxonomyTypeAction.payload],
      };
    case actions.CareerActionType.REMOVE_BOOKMARK:
      return {
        ...prev,
        removeBookmarkStatus: LoadingStates.STARTED,
        errorMessage: '',
      };
    case actions.CareerActionType.REMOVE_BOOKMARK_FAILED:
      return {
        ...prev,
        removeBookmarkStatus: LoadingStates.FAILED,
        errorMessage: (action as IActionFailed).errorMessage,
      };
    case actions.CareerActionType.REMOVE_BOOKMARK_SUCCESS:
      const removeBookmarkAction = action as IActionSuccess<string>;
      return {
        ...prev,
        removeBookmarkStatus: LoadingStates.SUCCEEDED,
        bookmarks: prev.bookmarks.filter((bookmark) => bookmark.id !== removeBookmarkAction.payload),
      };

    case actions.CareerActionType.TOGGLE_CHAT:
      return {
        ...prev,
        isChatOpen: !prev.isChatOpen,
        isChatInIntialState: false,
      };

    default:
      return prev;
  }
}
